import { createSlice } from "@reduxjs/toolkit";
import { FONTS, LINESPACING, TEXTALIGN } from "../../constants/inputValues";

const initialState = {
  isOverlayModal: false,
  activeTab: "",
  showEditor: false,
  pasteQr: false,
  uploadedFile: null,
  iconToAdd: null,
  overlayFiles: [],
  canvasSize: { w: 0, h: 0 },
  setIsResized: false,
  head: {
    text: "",
    font: FONTS[0],
    size: 36,
    color: "#796FEF",
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    align: TEXTALIGN[1],
    lineSpacing: LINESPACING[2],
  },
  subHead: {
    text: "",
    font: FONTS[0],
    size: 28,
    color: "#9B27AF",
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    align: TEXTALIGN[1],
    lineSpacing: LINESPACING[2],
  },
  body: {
    text: "",
    font: FONTS[0],
    size: 20,
    color: "#727272",
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    align: TEXTALIGN[1],
    lineSpacing: LINESPACING[2],
  },
};

const qrOverlay = createSlice({
  name: "qrOverlay",
  initialState,
  reducers: {
    setIsOverlayModal(state, { payload }) {
      state.isOverlayModal = payload;
    },
    setActiveTab(state, { payload }) {
      state.activeTab = payload;
    },
    setShowEditor(state, { payload }) {
      state.showEditor = payload;
    },
    setPasteQr(state, { payload }) {
      state.pasteQr = payload;
    },
    setHeadText(state, { payload }) {
      state.head = payload;
    },
    setSubHeadText(state, { payload }) {
      state.subHead = payload;
    },
    setBodyText(state, { payload }) {
      state.body = payload;
    },
    setUploadedFile(state, { payload }) {
      state.uploadedFile = payload;
    },
    setIconToAdd(state, { payload }) {
      state.iconToAdd = payload;
    },
    resetQrOverlay() {
      return initialState;
    },
    setOverlayFiles(state, { payload }) {
      state.overlayFiles = payload;
    },
    setCanvasSize(state, { payload: { w, h } }) {
      state.canvasSize = { w, h };
    },
    setIsResized(state, { payload }) {
      state.isResized = payload;
    },
  },
  extraReducers: {},
});
export const {
  setIsOverlayModal,
  setActiveTab,
  setShowEditor,
  setPasteQr,
  setHeadText,
  setSubHeadText,
  setBodyText,
  setUploadedFile,
  setIconToAdd,
  resetQrOverlay,
  setOverlayFiles,
  setCanvasSize,
  setIsResized,
} = qrOverlay.actions;
export default qrOverlay.reducer;
